import { render, staticRenderFns } from "./monitor-17.vue?vue&type=template&id=0b0aa33f&scoped=true"
import script from "./monitor-17.vue?vue&type=script&lang=js"
export * from "./monitor-17.vue?vue&type=script&lang=js"
import style0 from "./monitor-17.vue?vue&type=style&index=0&id=0b0aa33f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0aa33f",
  null
  
)

export default component.exports